import permissions from "@/plugins/permissions.js";

import ClientDashboard from "@/pages/client/index.vue";
import Operation from "@/pages/client/operation/Operation.vue";

import Branch from "@/pages/client/branch/Parent.vue";
import BranchList from "@/pages/client/branch/Branch.vue";
import AddBranch from "@/pages/client/branch/AddBranch.vue";
import EditBranch from "@/pages/client/branch/EditBranch.vue";

import Driver from "@/pages/client/driver/Parent.vue";
import DriverList from "@/pages/client/driver/Driver.vue";
import AddDriver from "@/pages/client/driver/AddDriver.vue";
import EditDriver from "@/pages/client/driver/EditDriver.vue";
import DriverDetail from "@/pages/client/driver/DriverDetail.vue";

import Vehicle from "@/pages/client/vehicle/Parent.vue";
import VehicleList from "@/pages/client/vehicle/Vehicle.vue";
import AddVehicle from "@/pages/client/vehicle/AddVehicle.vue";
import EditVehicle from "@/pages/client/vehicle/EditVehicle.vue";
import VehicleDetail from "@/pages/client/vehicle/VehicleDetail.vue";

import Warehouse from "@/pages/client/warehouse/Parent.vue";
import WarehouseList from "@/pages/client/warehouse/Warehouse.vue";
import AddWarehouse from "@/pages/client/warehouse/AddWarehouse.vue";
import EditWarehouse from "@/pages/client/warehouse/EditWarehouse.vue";

import IntegrationPartner from "@/pages/client/integration-partner/Parent.vue"
import IntegrationParnerList from "@/pages/client/integration-partner/IntegrationPartner.vue"
import AddIntegrationPartner from "@/pages/client/integration-partner/AddIntegrationPartner.vue"
import EditIntegrationPartner from "@/pages/client/integration-partner/EditIntegrationPartner.vue"


import Customer from "@/pages/client/customer/Parent.vue";
import CustomerList from "@/pages/client/customer/Customer.vue";
import CustomerDetails from "@/pages/client/customer/CustomerDetails.vue";
import CustomerStatistics from "@/pages/client/customer/CustomerStatistics.vue";

import ItemList from "@/pages/client/item/Item.vue";
import ItemUnitList from "@/pages/client/item-unit/ItemUnit.vue";
// import SaleOrderList from "@/pages/client/order/sale-order/SaleOrder.vue";
import SaleOrderNew from "@/pages/client/order/sale-order/SaleOrderNew.vue";
import AddDeliverySaleOrder from "@/pages/client/order/sale-order/AddDeliverySaleOrder.vue";
import EditDeliverySaleOrder from "@/pages/client/order/sale-order/EditDeliverySaleOrder.vue";
import AddPickUpSaleOrder from "@/pages/client/order/sale-order/AddPickUpSaleOrder.vue";
import EditPickUpSaleOrder from "@/pages/client/order/sale-order/EditPickUpSaleOrder.vue";

import User from "@/pages/client/user-management/Parent.vue";
import UserList from "@/pages/client/user-management/UserManagement.vue";
import AddNormalUser from "@/pages/client/user-management/AddNormalUser.vue";
import EditNormalUser from "@/pages/client/user-management/EditNormalUser.vue";

import Consignee from "@/pages/client/consignee/Parent.vue";
import ConsigneeList from "@/pages/client/consignee/Consignee.vue";
import AddConsignee from "@/pages/client/consignee/AddConsignee.vue";
import EditConsignee from "@/pages/client/consignee/EditConsignee.vue";

// import TripList from "@/pages/client/trip/Trip.vue";
import Trip from "@/pages/client/trip/Parent.vue";
import TripList from "@/pages/client/trip/Trip.vue";
import AddTrip from "@/pages/client/trip/AddTrip.vue";
import EditTrip from "@/pages/client/trip/EditTrip.vue";
import AddAdhocTrip from "@/pages/client/trip/AddAdhocTrip.vue";
import EditAdhocTrip from "@/pages/client/trip/EditAdhocTrip.vue";
// import TripDetails from "@/pages/client/trip/TripDetails.vue";
import MarkTripAsComplete from "@/pages/client/trip/MarkTripAsComplete.vue";

import TripPlanning from "@/pages/client/trip-planning/Parent.vue";
import TripPlanningList from "@/pages/client/trip-planning/TripPlanning.vue";
import TripPlanDetails from "@/pages/client/trip-planning/TripPlanDetails.vue";

import TripPlanningTemplate from "@/pages/client/trip-planning-template/Parent.vue";
import TripPlanningTemplateList from "@/pages/client/trip-planning-template/TripPlanningTemplate.vue";
import AddTripPlanningTemplate from "@/pages/client/trip-planning-template/AddTripPlanningTemplate.vue";
import EditTripPlanningTemplate from "@/pages/client/trip-planning-template/EditTripPlanningTemplate.vue";

import RegionRestriction from "@/pages/client/region-restriction/Parent.vue";
import RegionRestrictionList from "@/pages/client/region-restriction/RegionRestriction.vue";
import AddRegionRestriction from "@/pages/client/region-restriction/AddRegionRestriction.vue";
import EditRegionRestriction from "@/pages/client/region-restriction/EditRegionRestriction.vue";

import DriverZone from "@/pages/client/driver-zone/Parent.vue";
import DriverZoneList from "@/pages/client/driver-zone/DriverZone.vue";
import AddDriverZone from "@/pages/client/driver-zone/AddDriverZone.vue";
import EditDriverZone from "@/pages/client/driver-zone/EditDriverZone.vue";

import PaymentMethod from "@/pages/client/payment-method/PaymentMethod.vue";
import FieldConfiguration from "@/pages/client/field-configuration/FieldConfiguration.vue";
import Tags from "@/pages/client/tags/Tags.vue";
// import AdhocOrder from "@/pages/client/order/adhoc-order/AdhocOrder.vue";
import AdhocOrderNew from "@/pages/client/order/adhoc-order/AdhocOrderNew.vue";
import AddAdhocOrder from "@/pages/client/order/adhoc-order/AddAdhocOrder.vue";
import EditAdhocOrder from "@/pages/client/order/adhoc-order/EditAdhocOrder.vue";
import CustomerAddressList from "@/pages/client/customer-address/CustomerAddress.vue";
import CustomerAddressDetails from "@/pages/client/customer-address/CustomerAddressDetails.vue";
import Reports from "@/pages/client/reports/ClientReport.vue";

import Role from "@/pages/client/role/Parent.vue";
import RoleList from "@/pages/client/role/Role.vue";
import AddRole from "@/pages/client/role/AddRole.vue";
import EditRole from "@/pages/client/role/EditRole.vue";

import IntegrationLogs from "@/pages/client/integration-logs/IntegrationLogs.vue";
import IntegrationDocs from "@/pages/client/integration-logs/IntegrationDocs.vue";
import CompanyConfiguration from "@/pages/client/company-configuration/CompanyConfiguration.vue";
import Support from "@/pages/client/support/Support.vue";
import TicketView from "@/pages/client/support/TicketView.vue";
import AddTicket from "@/pages/client/support/AddTicket.vue";

import Project from "@/pages/client/project/Parent.vue";
import ProjectList from "@/pages/client/project/Project.vue";
import AddProject from "@/pages/client/project/AddProject.vue";
import EditProject from "@/pages/client/project/EditProject.vue";

import CustomerLocationUpdate from "@/pages/client/customer-location-update-logs/CustomerLocationUpdateLogs.vue";

import OrderNew from "@/pages/client/order-new/OrderNew.vue";
import OrderItemSplit from "@/pages/client/order-new/OrderItemSplit.vue";
import OrderSplit from "@/pages/client/order-new/OrderSplit.vue";
import { checkifLoggedIn } from "@/utils/functions";

import ApiToken from "@/pages/client/api-token/ApiToken.vue";

import StorageType from "@/pages/client/storage-type/StorageTypeMatrix.vue"

export default [
  {
    path: "client-dashboard",
    name: "client-dashboard",
    component: ClientDashboard,
  },
  {
    path: "operation",
    name: "operation",
    component: Operation,
  },
  {
    path: "project",
    name: "project",
    component: Project,
    redirect: { name: "project-list" },
    children: [
      {
        path: "list",
        name: "project-list",
        component: ProjectList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-project",
        component: AddProject,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-project",
        component: EditProject,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "branch",
    name: "branch",
    component: Branch,
    redirect: { name: "branch-list" },
    children: [
      {
        path: "list",
        name: "branch-list",
        component: BranchList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-branch",
        component: AddBranch,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-branch",
        component: EditBranch,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "driver",
    name: "driver",
    component: Driver,
    redirect: { name: "driver-list" },
    children: [
      {
        path: "list",
        name: "driver-list",
        component: DriverList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("fleet", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-driver",
        component: AddDriver,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("fleet", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-driver",
        component: EditDriver,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("fleet", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "view/:id",
        name: "driver-detail",
        component: DriverDetail,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("fleet", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "vehicle",
    name: "vehicle",
    component: Vehicle,
    redirect: { name: "vehicle-list" },
    children: [
      {
        path: "list",
        name: "vehicle-list",
        component: VehicleList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("fleet", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-vehicle",
        component: AddVehicle,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("fleet", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-vehicle",
        component: EditVehicle,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("fleet", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "view/:id",
        name: "vehicle-detail",
        component: VehicleDetail,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("fleet", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "warehouse",
    name: "warehouse",
    component: Warehouse,
    redirect: { name: "warehouse-list" },
    children: [
      {
        path: "list",
        name: "warehouse-list",
        component: WarehouseList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-warehouse",
        component: AddWarehouse,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-Warehouse",
        component: EditWarehouse,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "integration-partner",
    name: "integration-partner",
    component: IntegrationPartner,
    redirect: { name: "integration-partner-list" },
    children: [
      {
        path: "list",
        name: "integration-partner-list",
        component: IntegrationParnerList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-integration-partner",
        component: AddIntegrationPartner,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-integration-partner",
        component: EditIntegrationPartner,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "customer",
    name: "customer",
    component: Customer,
    redirect: { name: "customer-list" },
    children: [
      {
        path: "list",
        name: "customer-list",
        component: CustomerList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("customer", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "details/:id",
        name: "customer-details",
        component: CustomerDetails,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("customer", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "statistics/:id",
        name: "customer-statistics",
        component: CustomerStatistics,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("customer", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "customer-location-update",
        name: "customer-location-update-list",
        component: CustomerLocationUpdate,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("customer", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "customer-address",
    name: "customer-address-list",
    component: CustomerAddressList,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("customer", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "customer-address-details/:id",
    name: "customer-address-details",
    component: CustomerAddressDetails,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("customer", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "item",
    name: "item-list",
    component: ItemList,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("item", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "item-unit",
    name: "item-unit-list",
    component: ItemUnitList,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("item", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "payment-method",
    name: "payment-method",
    component: PaymentMethod,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("configuration", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "order-new",
    name: "order-new",
    component: OrderNew,
    props: true,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "order-item-split/:id",
    name: "order-item-split",
    component: OrderItemSplit,
    props: true,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "change")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "order-split/:id",
    name: "order-split",
    component: OrderSplit,
    props: true,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "change")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  // {
  //   path: "sale-order",
  //   name: "sale-order-new",
  //   component: SaleOrderNew,
  //   props: true,
  //   beforeEnter: (to, from, next) => {
  //     if (checkifLoggedIn()) next();
  //     else next({ name: "login" });
  //     if (permissions.getPermission("order", "view")) next();
  //     else next({ name: "error-page", params: { status: 403 } });
  //   },
  // },
  {
    path: "sale-order/add-delivery-order",
    name: "add-delivery-sale-order",
    component: AddDeliverySaleOrder,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "add")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "sale-order/edit-delivery-order/:id",
    name: "edit-delivery-sale-order",
    component: EditDeliverySaleOrder,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "change")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "sale-order/add-pickup-order",
    name: "add-pickup-sale-order",
    component: AddPickUpSaleOrder,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "add")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "sale-order/edit-pickup-order/:id",
    name: "edit-pickup-sale-order",
    component: EditPickUpSaleOrder,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "change")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  // {
  //   path: "adhoc-order",
  //   name: "AdhocOrderList",
  //   component: AdhocOrderList,
  // },
  // {
  //   path: "adhoc-order",
  //   name: "adhoc-order-new",
  //   component: AdhocOrderNew,
  //   props: true,
  //   beforeEnter: (to, from, next) => {
  //     if (checkifLoggedIn()) next();
  //     else next({ name: "login" });
  //     if (permissions.getPermission("order", "view")) next();
  //     else next({ name: "error-page", params: { status: 403 } });
  //   },
  // },
  {
    path: "adhoc-order/add-adhoc-order",
    name: "add-adhoc-order",
    component: AddAdhocOrder,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "add")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "adhoc-order/edit-adhoc-order/:id",
    name: "edit-adhoc-order",
    component: EditAdhocOrder,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("order", "change")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "user",
    name: "user",
    component: User,
    redirect: { name: "user-list" },
    children: [
      {
        path: "list",
        name: "user-list",
        component: UserList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("user", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "normal/add",
        name: "add-normal-user",
        component: AddNormalUser,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("user", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "normal/edit/:id",
        name: "edit-normal-user",
        component: EditNormalUser,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("user", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "consignee-management",
    name: "consignee-management",
    component: Consignee,
    redirect: { name: "consignee-list" },
    children: [
      {
        path: "list",
        name: "consignee-list",
        component: ConsigneeList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("user", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "normal/add",
        name: "add-consignee",
        component: AddConsignee,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("user", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "normal/edit/:id",
        name: "edit-consignee",
        component: EditConsignee,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("user", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "trip",
    name: "trip",
    component: Trip,
    redirect: { name: "trip-new" },
    children: [
      {
        path: "list",
        name: "trip-new",
        component: TripList,
        props: true,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add-adhoc",
        name: "add-adhoc-trip",
        component: AddAdhocTrip,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit-adhoc/:id",
        name: "edit-adhoc-trip",
        component: EditAdhocTrip,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-trip",
        component: AddTrip,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-trip",
        component: EditTrip,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "mark-as-complete/:id",
        name: "mark-trip-as-complete",
        component: MarkTripAsComplete,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },

  // {
  //   path: "trip/details",
  //   name: "trip-details",
  //   component: TripDetails,
  //   beforeEnter: (to, from, next) => {
  // if (checkifLoggedIn()) next();
  //   else next({ name: "login" });
  //     if (permissions.getPermission("trip", "view")) next();
  //     else next({ name: "error-page", params: { status: 403 } });
  //   },
  // },
  {
    path: "trip-planning",
    name: "trip-planning",
    component: TripPlanning,
    redirect: { name: "trip-planning-list" },
    children: [
      {
        path: "list",
        name: "trip-planning-list",
        component: TripPlanningList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "plan-details/:id",
        name: "trip-plan-details",
        component: TripPlanDetails,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "trip-planning-template",
    name: "trip-planning-template",
    component: TripPlanningTemplate,
    redirect: { name: "trip-planning-template-list" },
    children: [
      {
        path: "list",
        name: "trip-planning-template-list",
        component: TripPlanningTemplateList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-trip-planning-template",
        component: AddTripPlanningTemplate,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-trip-planning-template",
        component: EditTripPlanningTemplate,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "region-restriction",
    name: "region-restriction",
    component: RegionRestriction,
    redirect: { name: "region-restriction-list" },
    children: [
      {
        path: "list",
        name: "region-restriction-list",
        component: RegionRestrictionList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-region-restriction",
        component: AddRegionRestriction,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-region-restriction",
        component: EditRegionRestriction,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "driver-zone",
    name: "driver-zone",
    component: DriverZone,
    redirect: { name: "driver-zone-list" },
    children: [
      {
        path: "list",
        name: "driver-zone-list",
        component: DriverZoneList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-driver-zone",
        component: AddDriverZone,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-driver-zone",
        component: EditDriverZone,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("trip_planning", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "field-configuration",
    name: "field-configuration",
    component: FieldConfiguration,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("configuration", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "tags",
    name: "tags",
    component: Tags,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("configuration", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "reports",
    name: "reports",
    component: Reports,
  },
  {
    path: "role",
    name: "role",
    component: Role,
    redirect: { name: "role-list" },
    children: [
      {
        path: "list",
        name: "role-list",
        component: RoleList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "view")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "add",
        name: "add-role",
        component: AddRole,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "add")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
      {
        path: "edit/:id",
        name: "edit-role",
        component: EditRole,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
          if (permissions.getPermission("configuration", "change")) next();
          else next({ name: "error-page", params: { status: 403 } });
        },
      },
    ],
  },
  {
    path: "integration-logs",
    name: "integration-logs",
    component: IntegrationLogs,
  },
  {
    path: "integration-docs",
    name: "integration-docs",
    component: IntegrationDocs,
  },
  {
    path: "company-configuration",
    name: "company-configuration",
    component: CompanyConfiguration,
  },
  {
    path: "support",
    name: "support",
    component: Support,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("configuration", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "ticket/view/:id",
    name: "ticket-view",
    component: TicketView,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("configuration", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "ticket/add",
    name: "add-ticket",
    component: AddTicket,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("configuration", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "api-token",
    name: "api-token",
    component: ApiToken,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("configuration", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
  {
    path: "storage-type",
    name: "storage-type",
    component: StorageType,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
      if (permissions.getPermission("configuration", "view")) next();
      else next({ name: "error-page", params: { status: 403 } });
    },
  },
];
